/**
 * 取引先一覧検索条件VOクラス
 */
export class KYMW0400OutputModel {
  /** 取引先コード */
  public supplierCode: string = null;
  /** 取引先名 */
  public supplierNameKanji: string = null;
  /** 取扱停止区分 */
  public tradeStopDiv: string = null;
  /** 呼出元区分 */
  public supplierFlg: string = null;
  /** 複数選択の場合の取引先 */
  public multiSuppliers: Supplier[] = [];
}

export class Supplier {
  /** 取扱停止区分 */
  public tradeStopDiv: string = null;
  /** 取引先コード */
  public supplierCode: string = null;
  /** 取引先名 */
  public supplierNameKanji: string = null;
}